/**
 * Created by yniran on 12/13/14.
 */

define(function (require) {

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        LEConfig = require("assets/config/le-env-conf"),
        ChatContactModel = require("connection-models/chatTab/ChatContactModel"),
        ChatContactsCollection = require("connection-collections/chatTab/ChatContactsCollection"),
        ChatContactsProfilesListView = require("connection-views/chatTab/ChatContactsProfilesListView"),
        ChatContactsLayout = require("connection-views/layouts/chatTab/ChatContactsLayout"),
        ChatContactsAvailabilityController = require("connection-controllers/chatTab/ChatContactsAvailabilityController"),
        OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator"),
        ChatContactsController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatContactsController = Marionette.Controller.extend({

            initialize: function (options) {

                logger.debug("initialize : entered", "ChatContactsController.initialize");

                this._chatChannel = options.chatChannel;
                this._filterInfo = null;
                this._externalRequestData = null;  //used for cases when an external request to chat will come in before groups are retrieved from server
                this._chatContactsLayout = new ChatContactsLayout();
                this._contextModel = options.contextModel;
                this._receivedEngagements = 0;

                this._initializeAvailabilityController();
                this._getContactsInfo();
                this._bindEvents();
                this._showContactsLayout();
            },

            _initializeAvailabilityController: function () {

                this._availabilityController = new ChatContactsAvailabilityController({
                    chatChannel: this._chatChannel,
                    contextModel: this._contextModel
                });
            },

            _showContactsLayout: function () {
                this._chatChannel.vent.trigger("cpChatUI::showRegion:chatContacts", {view: this._chatContactsLayout});
            },

            _bindEvents: function () {

                this.listenTo(this._chatContactsLayout, "render", this._onContactsLayoutRendered);
                this.listenTo(this._chatContactsLayout, "contacts:filter:term:change", this._filterContacts);
                this.listenTo(this._availabilityController, "chatContacts:availability:retrieved", this._onAvailabilityRetrieved);
                this.listenTo(LEConnection.vent, "chatContacts:engagements:retrieved", this._onEngagementsRetrieved);
                this.listenTo(LEConnection.vent, "tryPushingSDEs",this._tryPushingSDEs);
                this.listenTo(LEConnection.vent, "Chat:requested", this._onExternalChatRequest);
                this.listenTo(this._chatChannel, 'messaging:notificationsChanged', this._updateNotificationCounter);
                this.listenTo(this._chatChannel, 'chat:notifications:incrementCounter', this._incrementNotifications);
                this.listenTo(this._chatChannel, 'chat:notifications:resetCounter', this._resetChatNotificationCounter);
            },

            _onContactsLayoutRendered: function () {

                this._contactsGroupsListView = new ChatContactsProfilesListView({
                    hideOnAllOffline: false,
                    collection: this._contextModel.getContacts(),
                    contactType: CP_CONST.CONTACT_TYPE.GROUP,
                    title: "LEConnection.chat.livePersonChatWidgetLivePersonTeams"});

                this._chatContactsLayout.contactsGroupsRegion.show(this._contactsGroupsListView);
                this.listenTo(this._contactsGroupsListView, "chat:contact:profile:click", this._onChatContactProfileClick);

                this._contactsUsersListView = new ChatContactsProfilesListView({
                    hideOnAllOffline: true, //set this back to true
                    collection: this._contextModel.getContacts(),
                    contactType: CP_CONST.CONTACT_TYPE.USER,
                    title: "LEConnection.chat.livePersonChatWidgetLivePersonEmployees"});

                this._chatContactsLayout.contactsUsersRegion.show(this._contactsUsersListView);
                this.listenTo(this._contactsUsersListView, "chat:contact:profile:click", this._onChatContactProfileClick);
            },

            _onAvailabilityRetrieved: function (info) {   //merge the availability information into the contacts collection (users/groups)

                var contacts;

                logger.debug("received notification that availability was retrieved", "ChatContactsController._onAvailabilityRetrieved");

                // switch (info.contactType) {
                //     case CP_CONST.CONTACT_TYPE.GROUP:
                contacts = this._contextModel.getContacts();
                //         break;
                //     case CP_CONST.CONTACT_TYPE.USER:
                //         contactsCollection = this._contacts.usersCollection;
                //         break;
                // }

                if (contacts) {
                    contacts.set(info.collection.models, {add: false, merge: true, remove: false});   //merge the availability info into contacts collection

                    if (info.contactType === CP_CONST.CONTACT_TYPE.UNDEFINED) {
                        // display a group as available even if its not iff its backup group is available
                        contacts.each(function(model) {
                            // var availability = model.get("availability");
                            var backupModel = contacts.findWhere({"skillName": model.getBackupSkillName()});
                            if(backupModel) {
                                model.setBackupAvailability(backupModel.getAvailability());
                            }
                        });
                    }
                }
            },

            _onEngagementsRetrieved: function (engagement) {
                var contacts;
                var model;

                contacts = this._contextModel.getContacts();
                model = contacts.findWhere({"skillName": engagement.engagementName});
                if(model) {
                    this._receivedEngagements += 1;
                    model.set("engagementId", engagement.engagementId);
                    model.set("campaignId", engagement.campaignId);
                    model.set("contextId", engagement.contextId);
                    if(model.isMessagingContact()){
                        model.set("isMessagingContactReady", true);
                        model.set("availability", true);
                        this._chatChannel.vent.trigger("contacts:messagingcontact:received", model);
                    }
                }

                if (contacts.findWhere({"conversationType": "messaging", "isMessagingContactReady": false}) === undefined){
                    this._closeLoader();
                }
            },

            _onExternalChatRequest: function (options) {

                logger.debug("received external request to start chat with contact ", "ChatContactsController._onExternalChatRequest", options);

                if (options.group) { //only supporting external request to group(skill)

                    this._externalRequestData = options;

                    if (this._contextModel.getContacts()) {
                        this._startChatFlowForExternalRequestGroup(); //can start flow immediately
                    }
                    else {
                        logger.debug("queuing request data to chat until groups are fetched from server", "ChatContactsController._onExternalChatRequest");
                    }
                }
                else {
                    logger.warn("didnt receive group=skillname to start chat with ", "ChatContactsController._onExternalChatRequest");
                }
            },

            _startChatFlowForExternalRequestGroup: function () {

                var data = this._externalRequestData;
                this._externalRequestData = null;

                if (data && data.group) {
                    if (this._contextModel.getContacts()) {

                        var groupModel = this._contextModel.getContacts().find(function (model) {
                            return model.get("skillName") === data.group;
                        });

                        if (groupModel) {
                            logger.debug("about to find group model to start chat for external request, id = " + data.group, "ChatContactsController._startChatFlowForExternalRequestGroup");
                            this._chatChannel.vent.trigger("chat:start:request", {model: groupModel, referrerAction: data.referrerAction});
                        }
                        else {
                            logger.warn("couldn't find model for group: " + data.group, "ChatContactsController._startChatFlowForExternalRequestGroup");
                            this._chatChannel.vent.trigger("cpChatUI:error", {errorType: CP_CONST.CHAT_ERROR_TYPES.GROUP_NOT_FOUND});
                        }
                    }
                }
            },

            _filterContacts: function (options) {

                var term = options.term.replace(/\s\s*$/, "");

                logger.debug("about to filter contacts based on term: '" + term + "'", "ChatContactsController._filterContacts");

                if (term.length > 0) {

                    var predicate = this._getFilteringPredicate(term);

                    this._filterInfo = {filterModel: {
                        predicate: predicate,
                        filteredWith: term
                    }};
                }
                else {
                    if (this._filterInfo && this._filterInfo.filterModel) {
                        this._filterInfo.filterModel = null;
                    }
                }

                this._contextModel.getContacts().organize(this._filterInfo);
                // this._contacts.usersCollection.organize(this._filterInfo);
            },

            _getFilteringPredicate: function (term) {
                term = term.toLowerCase();
                return function (model) {  //model will be passed by the CollectionFilterer class
                    var index = (term.length > 0 ? model.get("displayName").toLowerCase().indexOf(term) : -1);
                    return ((term.length > 2 && index > -1) || index === 0); //if term shorter than 2 chars only include matches on the beginning, if longer include anything that matches
                };
            },

            _onChatContactProfileClick: function (data) {
                var model = data.model;

                logger.debug("received chat contact profile click event", "ChatContactsController._onChatContactProfileClick", model);

                // if its a chatskill and the premier skill is unavailable, choose the backupskill
                if (!model.getAvailability() && model.getBackupAvailability() && model.getBackupSkillName()) {
                    model = this._contextModel.getContacts().findWhere({"skillName": model.getBackupSkillName()});
                }
                if (model.get("availability")) {
                    this._chatChannel.vent.trigger("chat:start:request", {model: model});
                } else {// check for an offline survey
                    this._chatChannel.vent.trigger("chat:getOfflineSurvey", {skill: data.model.get("skillName")});
                }
            },

            _getContactsInfo: function () {
                this._contextModel.setContacts(this._getContactsInfoForType(CP_CONST.CONTACT_TYPES.ALL));
                //this._contacts.usersCollection = this._getContactsInfoForType(CP_CONST.CONTACT_TYPE.USER);
                //this._contacts.groupsCollection = this._getContactsInfoForType(CP_CONST.CONTACT_TYPE.GROUP);
            },

            _getContactsInfoForType: function (type) {
                var coll = new ChatContactsCollection(null, {contactTypes: type, chatChannel: this._chatChannel});
                var decorated = this._decorateContactsCollection(coll);

                coll.fetch({
                    success: _.bind(this._onContactsRetrieveSuccess, this),
                    error: _.bind(this._onContactsRetrieveFail,  this)
                });

                return decorated;
            },

            _decorateContactsCollection: function (collection) {
                return OrganizeCollectionDecorator.decorate(collection, {
                    lazy: true
                });
            },


            _tryPushingSDEs: function () {
                this._setLoader();
                var contacts = this._contextModel.getContacts();
                if (contacts && lpTag.sdes) {
                    // so this approach works without houston involvment
                    contacts.each(function (contact) {
                        var fixedContactName  = (contact.get("skillName") || "").replace(" ", "");
                        window.lpTag.sdes.push({"type": "pagediv", "divId": fixedContactName});
                    });
                    // we need this for authenticated messaging !!!
                    var customerId = LE.sessionManager.getUserId() + "_" + LE.sessionManager.getAccountId();
                    lpTag.sdes.push({"type":"ctmrinfo","info":{"customerId":customerId}});
                    // start engagement timer, note the timeout is taken from le-ui-automation, its the engagement waittime
                    setTimeout(_.bind(this._verifyEngagementsLoaded(contacts.length), this), CP_CONST.ENGAGEMENTS_WAIT_TIME);
                }
            },


            _onContactsRetrieveSuccess: function (collection) {
                logger.debug("successfully retrieved contacts collection for type: " + collection.getContactTypes(), "ChatContactsController._onContactsRetrieveSuccess");
                if (collection.getContactTypes() === CP_CONST.CONTACT_TYPES.ALL) {
                    //this._closeLoader();
                    this._tryPushingSDEs();
                    if (this._externalRequestData) { //external request to start chat already received
                        this._startChatFlowForExternalRequestGroup();
                    }
                }
            },

            _onContactsRetrieveFail: function (collection, data) {
                if (collection.getContactTypes() ===  CP_CONST.CONTACT_TYPES.ALL) {
                    //this._closeLoader();
                    this._useFallbackContactsIfExisting(collection);
                    this._tryPushingSDEs(); // we also trying to push SDE, since we now support messaging contacts
                }
                logger.error("failed to retrieve contacts!!!", "ChatContactsController._onContactsRetrieveFail", data);
            },

            _useFallbackContactsIfExisting: function (collection) {
                var isExisting = this._initFallbackContactsFromConfig();
                if (isExisting) {
                    collection.add(this.fallbackContacts);
                    this._contextModel.getContacts().organize();
                    this._contextModel.getContacts().trigger("add:fallbackContacts");
                }
            },

            _initFallbackContactsFromConfig: function () {
                var attributes,
                    isAuthenticated = LE.sessionManager.isAuthenticated(),
                    chatSettings = LEConfig.connectionPanelChatSettings || {};

                this.fallbackContacts = [];
                if (isAuthenticated && chatSettings.hasOwnProperty('fallbackSupportContact')) {
                    attributes = chatSettings.fallbackSupportContact;
                    this.fallbackContacts.push(new ChatContactModel(attributes));
                }
                if (chatSettings.hasOwnProperty('fallbackSalesContact')) {
                    attributes = chatSettings.fallbackSalesContact;
                    this.fallbackContacts.push(new ChatContactModel(attributes));
                }
                return this.fallbackContacts.length > 0;
            },

            _setLoader:function(){
                this._chatContactsLayout.setLoader();
            },

            _closeLoader: function () {
                this._chatContactsLayout.closeLoader();
            },

            _getContactBySkillName: function (skillName){
                 return _.find(this._contextModel.getContacts().models, function(contact){return contact.getSkillName() == skillName;});
            },

            _updateNotificationCounter: function (skillName, counter){
                var changedModel = this._getContactBySkillName(skillName);
                if(changedModel) {
                    changedModel.set("notificationCounter", counter);
                }
            },
            _resetChatNotificationCounter: function(skillName){
                this._updateNotificationCounter(skillName, 0);
            },
            _incrementNotifications: function(skillName, increment, isChatResumed){
                var changedModel = this._getContactBySkillName(skillName);
                if(changedModel) {
                    var currentCounter = changedModel.get("notificationCounter") || 0;
                    currentCounter += increment;
                    if(isChatResumed){
                        currentCounter = parseInt(LEConnection.parentManager.getFromLocalStorage(skillName + "NotificationCounter"),10);
                    }
                    changedModel.set("notificationCounter", currentCounter);
                    LEConnection.parentManager.saveInLocalStorage(skillName + "NotificationCounter", currentCounter);
                }
            },

            _verifyEngagementsLoaded: function (numberOfEngagements) {
                return function () {
                    // if we don't have all engagements, lets still close the loader
                    this._closeLoader();
                    if(this._receivedEngagements < numberOfEngagements){
                        if(this._receivedEngagements === 0){
                            logger.error('ENGAGEMENTS ERROR, 0 Engagements received', 'ChatContactsController._tryPushingSDEs');
                        }else{
                            logger.warn('ENGAGEMENTS WARNING, not all engagements received', 'ChatContactsController._tryPushingSDEs');
                        }
                    }
                };
            }
        });
    });

    return ChatContactsController;
});
